<template>
    <div class="modal" id="modalAgendar">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Agenda tu cita!</h4>
                </div>
                <div class="modal-body">
                    <b-row>
                        <b-col cols="12">
                            <span class="text-span"
                                >Diligencie la siguiente información para
                                agendar su cita, el asesor
                                <b>nombre asesor</b> se pondrá en contacto con
                                usted para confirmar la información
                                registrada.</span
                            >
                        </b-col>
                        <b-col cols="12" class="mt-3 mb-2">
                            <label>
                                <small> No hay obligación de comprar.</small> Por
                                favor seleccione un día y una hora.</label
                            >
                            <!-- <calendarButtons /> -->
                        </b-col>
                        <b-col md="6">
                            <label class="form-label">Día</label>
                            <input type="date" class="form-control" />
                        </b-col>
                        <b-col md="6" cols="12">
                            <label class="form-label">Hora</label>
                            <input type="time" class="form-control" />
                        </b-col>
                    </b-row>
                    <hr />
                    <label for="">Confirma tu datos:</label>
                    <b-row>
                        <b-col md="6" class="mt-2">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Nombre Cliente"
                            />
                        </b-col>
                        <b-col md="6" cols="12" class="mt-2">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Teléfono"
                            />
                        </b-col>
                        <b-col md="12" cols="12" class="mt-2">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Correo"
                            />
                        </b-col>
                        <b-col cols="12">
                            <hr />
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                />
                                <label class="form-check-label">
                                    Autorizo el uso de mis datos para recibir
                                    información sobre promociones, eventos y
                                    descuentos.</label
                                >
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-md-center">
                        <b-col cols="6">
                            <button class="btn btn-block">Agendar</button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import calendarButtons from "./calendarButtons";
export default {
    components: {
        calendarButtons
    },
    data() {
        return {
            fecha: ""
        };
    }
};
</script>

<style lang="scss">
span.text-span {
    color: #6d7278;
    font-size: 1.2rem;
}
</style>
